import apiClient from '@/shared/api/client'
import type { CountMaster } from '@/shared/types/master'

interface ListParams {
  page?: number
  page_size?: number
  count_type?: string
  is_active?: boolean
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const countsApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<CountMaster>> => {
    const res = await apiClient.get<PaginatedResponse<CountMaster>>('/masters/counts', { params })
    return res.data
  },

  get: async (id: string): Promise<CountMaster> => {
    const res = await apiClient.get<CountMaster>(`/masters/counts/${id}`)
    return res.data
  },

  create: async (data: Omit<CountMaster, 'id'>): Promise<CountMaster> => {
    const res = await apiClient.post<CountMaster>('/masters/counts', data)
    return res.data
  },

  update: async (id: string, data: Partial<CountMaster>): Promise<CountMaster> => {
    const res = await apiClient.patch<CountMaster>(`/masters/counts/${id}`, data)
    return res.data
  },
}
